import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { api } from 'utils/axios';

const initialState = {
  loading: false,
  customerType: '',
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  address: null,
  comment: '',
  sf_account_id: '',
  sr_id: '',
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  areaStatus: true,
};

export const sendFormNotDTC = createAsyncThunk(
  'sendFormNot',
  async (args, { rejectWithValue, getState }) => {
    try {
      const { formNotDTC, global } = getState();
      const formData = new FormData();
      console.log(args);
      console.log(formNotDTC);
      formData.append('firstName', formNotDTC.firstName);
      formData.append('lastName', formNotDTC.lastName);
      formData.append('phone', formNotDTC.phone);
      formData.append('email', formNotDTC.email);
      formData.append(
        'state',
        formNotDTC.address ? formNotDTC.address.state : null
      );
      formData.append(
        'city',
        formNotDTC.address ? formNotDTC.address.city : null
      );
      formData.append(
        'zip',
        formNotDTC.address ? formNotDTC.address.zip : null
      );
      formData.append(
        'streetByGoogle',
        formNotDTC.address ? formNotDTC.address.streetByGoogle : null
      );
      formData.append(
        'millage',
        global.resDjangoGoogleApi
          ? global.resDjangoGoogleApi.data.distanceMiles
          : 0
      );
      formData.append(
        'insuranceFront',
        args.insuranceFront ? args.insuranceFront.files[0] : null
      );
      formData.append(
        'insuranceBack',
        args.insuranceBack ? args.insuranceBack.files[0] : null
      );
      if (args.labOrders) {
        args.labOrders.files.forEach((item) => {
          formData.append('labOrders', item);
        });
      } else {
        formData.append('labOrders', null);
      }
      formData.append('noteByCustomer', formNotDTC.comment);
      formData.append('customerType', formNotDTC.customerType);
      formData.append('sf_account_id', formNotDTC.sf_account_id);
      formData.append('timezone', formNotDTC.timezone);

      const response = await api.post('/ServiceRequestBusiness/', formData);

      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response.data);
    }
  }
);

export const sendZapier = createAsyncThunk(
  'sendZapier',
  async (args, { rejectWithValue, getState }) => {
    const { formNotDTC } = getState();
    const formData = new FormData();
    formData.append('firstName', formNotDTC.firstName);
    formData.append('lastName', formNotDTC.lastName);
    formData.append('phone', formNotDTC.phone);
    formData.append('email', formNotDTC.email);
    formData.append(
      'address',
      formNotDTC.address ? formNotDTC.address.full : null
    );
    formData.append('customerType', formNotDTC.customerType);

    try {
      const response = await axios.post(
        'https://hooks.zapier.com/hooks/catch/2616746/bhh3x7a/',
        formData
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sendZapierDjango = createAsyncThunk(
  'sendZapierDjango',
  async (args, { rejectWithValue, getState }) => {
    const { formNotDTC } = getState();
    const formData = new FormData();
    formData.append('first_name', formNotDTC.firstName);
    formData.append('last_name', formNotDTC.lastName);
    formData.append('phone', formNotDTC.phone);
    formData.append('email', formNotDTC.email);
    formData.append(
      'address',
      formNotDTC.address ? formNotDTC.address.full : null
    );
    formData.append('customerType', formNotDTC.customerType);

    try {
      const response = await api.post(
        '/create_salesforce_opportunity/',
        formData
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const formNotDTCSlice = createSlice({
  name: 'FormNotDTCSlice',
  initialState,
  reducers: {
    updateCustomerInfo(state, { payload }) {
      state.firstName = payload.firstName;
      state.lastName = payload.lastName;
      state.phone = payload.phone;
      state.email = payload.email;
      state.customerType = payload.customerType;
      state.sf_account_id = payload.sf_account_id;
    },
    fillPhone(state, { payload }) {
      state.phone = payload.phone;
    },
    fillEmail(state, { payload }) {
      state.email = payload.email;
    },
    fillAddress(state, { payload }) {
      state.address = {
        full: payload.address?.full || null,
        state: payload.addressObj?.state || null,
        city: payload.addressObj?.city || null,
        zip: payload.addressObj?.zip || null,
        streetByGoogle: payload.addressObj?.street1 || null,
      };
    },
    fillComment(state, { payload }) {
      state.comment = payload.comment;
    },
    updateStatusOfArea(state, { payload }) {
      state.areaStatus = payload.areaStatus;
    },
  },
  extraReducers: (builder) => {
    builder

      // Send Form Data //
      .addCase('sendFormNot/pending', (state) => {
        state.loading = true;
      })
      .addCase('sendFormNot/fulfilled', (state, { payload }) => {
        state.loading = false;
        state.sr_id = payload.sr_id;
      })
      .addCase('sendFormNot/rejected', (state) => {
        state.loading = false;
      })

      // Send Zapier (ADDRESS NOT FOUND CONDITION)//
      .addCase('sendZapier/pending', (state) => {
        state.loading = true;
      })
      .addCase('sendZapier/fulfilled', (state) => {
        state.loading = false;
      })
      .addCase('sendZapier/rejected', (state) => {
        state.loading = false;
      })

      // Send Zapier Django (ADDRESS NOT FOUND CONDITION)//
      .addCase('sendZapierDjango/pending', (state) => {
        state.loading = true;
      })
      .addCase('sendZapierDjango/fulfilled', (state) => {
        state.loading = false;
      })
      .addCase('sendZapierDjango/rejected', (state) => {
        state.loading = false;
      });
  },
});

export const {
  updateCustomerInfo,
  fillPhone,
  fillEmail,
  fillAddress,
  fillComment,
  updateStatusOfArea,
} = formNotDTCSlice.actions;

export default formNotDTCSlice.reducer;
